import { ConfigProperties } from 'src/app/shared/models/config';
import { PaymentCartTypeType } from 'src/app/shared/models/payment-type';

export class ConfigAlliance implements ConfigProperties {
    constructor(
        public allowContinueWithAWBNotFound = true,
        public allowMultipleAWBsPayment = true,
        public minimumAmountAllowed = 0,
        public allowStoragePaymentsWithoutISC = true,
        public enablePaymentHistory = true,
        public enableSearchByFlightNumber = true,
        public allowPaymentsWithoutISCPaid = true,
        public forceToRedirectionToCharges = true,
        public enableNomination = true,
        public creditCardAnnouncement = 'Please note that CargoSprint LLC manages the guest shopping cart and will be reflected as such on your credit card statement. The payment will be processed and finalized through AGI Cargo on your behalf. After completing the transaction, kindly review the receipt for comprehensive details, including how it will appear on your credit card statement.',
        public disableChargeButtonWhenStatusDLV = true,
        public paymentCartType = PaymentCartTypeType.MAWB,
        public logicBaseOnFlightNumberAndFlightDate = true,
        public enablePickupTimeOnPickupDate = true,
        public acceptCompanyPolicyRequired = true,
        public enableAGIWallet = true,
        public calculateQuantityOnExtraItems = false,
        public enableMessageForAmountZero = false,
        public enablePromoCode = true,
        public enableSearchButtonOutside = true,
        public enableRequestorApprovalFlow = true,
        public enableEchecksAsGuestPayment = true,
        public optimizeCalculationStorage = true,
        public collectCompanyInformationByPayment = true,
        public enableDynamicFields = true,
        public enableTransferCart = false,
        public enableFAQPDF = true,
        public areTermsOfUseExternal = false,
        public enableAutoPaySubscription = true,
        public maxWidthHeader = '1120px',
        public enableChargeEdition = false,
        public allowPaymentsWithoutShipmentInformation = true,
        public enableThresholdReceiptAPISwitch = true,
        public enableCreditCardVerification = true
    ) {}
}
